import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      appTitle: 'Jani',
      timeTracking: 'Time Tracking',
      dashboard: 'Dashboard',
      projects: 'Projects',
      clients: 'Clients',
      teams: 'Teams',
      reports: 'Reports',
      admin: 'Admin',
      login: 'Log in',
      logout: 'Log out',
      email: 'Email',
      password: 'Password',
      submit: 'Submit',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      name: 'Name',
      status: 'Status',
      actions: 'Actions',
      language: 'Language',
      loading: 'Loading...',
      error: 'Error',
      noData: 'No data found',
      hoursToday: 'Hours today',
      role: 'Role',
      client: 'Client',
      task: 'Task',
      date: 'Date',
      duration: 'Duration',
      note: 'Note',
      billable: 'Billable',
      createNew: 'Create new',
      search: 'Search',
      confirmDelete: 'Are you sure?',
      today: 'Today',
      thisWeek: 'This week',
      export: 'Export',
      exportExcel: 'Export Excel',
      exportCsv: 'Export CSV',
      generate: 'Generate',
      groupBy: 'Group by',
    },
  },
  fr: {
    translation: {
      appTitle: 'Jani',
      timeTracking: 'Suivi du temps',
      dashboard: 'Tableau de bord',
      projects: 'Projets',
      clients: 'Clients',
      teams: 'Équipes',
      reports: 'Rapports',
      admin: 'Admin',
      login: 'Connexion',
      logout: 'Déconnexion',
      email: 'Email',
      password: 'Mot de passe',
      submit: 'Soumettre',
      cancel: 'Annuler',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      name: 'Nom',
      status: 'Statut',
      actions: 'Actions',
      language: 'Langue',
    },
  },
  de: {
    translation: {
      appTitle: 'Jani',
      timeTracking: 'Zeiterfassung',
      dashboard: 'Dashboard',
      projects: 'Projekte',
      clients: 'Kunden',
      teams: 'Teams',
      reports: 'Berichte',
      admin: 'Admin',
      login: 'Anmelden',
      logout: 'Abmelden',
      email: 'E-Mail',
      password: 'Passwort',
      submit: 'Absenden',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      create: 'Erstellen',
      name: 'Name',
      status: 'Status',
      actions: 'Aktionen',
      language: 'Sprache',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
